 
<template>
  <el-select v-model="hospitalId" :style="{width:width}" @change="getChooseHospitalId" :disabled="disabled"
    filterable :loading="loading" clearable :placeholder="placeholder" :size="size" @>
    <el-option v-for="item in hospitalList" :key="item.id" :label="item.orgName" :value="item.id">
    </el-option>
  </el-select>
</template>
<script>
import { channelHospital } from "@/api/serviceOrder.js";
export default {
  data() {
    return {
      hospitalId: "",
      hospitalList: [],
      loading: false,
      hospitalName: ""
    };
  },
  props: {
    placeholder: {
      type: String,
      default: "请选择机构"
    },
    size: {
      type: String,
      require: false,
      default: ""
    },
    disabled: {
      type: Boolean,
      require: false,
      default: false
    },
    width: {
      type: String,
      require: false,
      default: ""
    },
    hospital: {
      type:String,
      require: false,
      default:''
    },
    hospitalState: { //1 合作状态 进行中 
      type:String, 
      default:''
    },
    hospitalDisabled: { //0  启用
      type:String, 
      default:''
    }
  },
  watch: { 
    hospital: {
      handler(newval) {  
        if (newval) { 
          this.hospitalId = newval
          //编辑回显 根据机构id 查找渠道类型 
          this.getChooseHospitalId(newval, true);
        }
      } 
    }
  },
  created() { 
    this.getHospitalList(); 
  },
  methods: {
    getHospitalList() {
      let temp = {
        size: 100,
        current: 1,
        state:this.hospitalState!=''?Number(this.hospitalState):'', //1 进行中
        disabled:this.hospitalDisabled!=''?Number(this.hospitalDisabled):'', // 0启用 1 禁用
        channelType:10564118, //渠道类型为 保险
        orgName: "", 
      };
      channelHospital(temp).then(res => {
        this.loading = false;
        this.hospitalList = res.data.records; 
        this.getChooseHospitalId(this.hospitalId, true);
      });
    },
    resettingVal() {
      this.hospitalId = ""; 
    },
    getChooseHospitalId(val, editeFlag) { 
      let channelId = ""; //渠道类型id
      this.hospitalList.forEach(item => {
        if (item.id == val) {
          this.hospitalName = item.orgName;
          channelId = item.channelType;
        }
      }); 
      //编辑页面回显时只处理渠道类型回显
      if (editeFlag) {
        this.$emit("getChooseHospitalId", false, channelId, this.hospitalName);
      } else { 
        this.$emit("getChooseHospitalId", val, channelId, this.hospitalName);
      }
    }
  }
};
</script>